import { AccountService, AccountSubscriber } from '../types';

export class SubscribedToAccount {
  static eventName = 'subscribed_to_account';

  accountSubscriber: AccountSubscriber;

  constructor(accountSubscriber: AccountSubscriber) {
    this.accountSubscriber = accountSubscriber;
  }
}

export class UnsubscribedFromAccount {
  static eventName = 'unsubscribed_from_account';

  accountSubscriber: AccountSubscriber;

  constructor(accountSubscriber: AccountSubscriber) {
    this.accountSubscriber = accountSubscriber;
  }
}

export class AccountLogoUploaded {
  static eventName = 'account_logo_uploaded';

  accountId: string;

  logoUrl: string;

  constructor(accountId: string, logoUrl: string) {
    this.accountId = accountId;
    this.logoUrl = logoUrl;
  }
}

export class AccountServiceEnabled {
  static eventName = 'account_service_enabled';

  accountService: AccountService;

  constructor(accountService: AccountService) {
    this.accountService = accountService;
  }
}

export class AccountServiceDisabled {
  static eventName = 'account_service_disabled';

  id: string;

  constructor(id: string) {
    this.id = id;
  }
}
